import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SeqValue } from '../../types';
import type { RootState } from '../store';
import { findIndex } from 'lodash-es';

export interface seqConsultState {
  // todo: currentStage 유니온 타입 필요
  currentStage: string;
  currentBuildingType: SeqValue | null;
  currentPyung: SeqValue | null;
  currentSpaceStatus: SeqValue | null;
  currentConsultPurpose: SeqValue | null;
  currentConstructionBudget: SeqValue | null;
  currentConstructionCase: SeqValue[];
  currentAllCase: SeqValue[];
  currentConstructionPeriod: SeqValue | null;
  currentConsultSchedule: SeqValue | null;
  currentCallTime: SeqValue | null;
  telCertificated: boolean;
}

const initialState: seqConsultState = {
  currentStage: 'CHOOSE_BUILDING_TYPE',
  currentBuildingType: null,
  currentPyung: null,
  currentSpaceStatus: null,
  currentConsultPurpose: null,
  currentConstructionBudget: null,
  currentConstructionCase: [],
  currentConstructionPeriod: null,
  currentAllCase: [],
  currentConsultSchedule: null,
  currentCallTime: null,
  telCertificated: false,
};

export const seqConsultSlice = createSlice({
  name: 'seqConsult',
  initialState,
  reducers: {
    /* 컴포넌트명 */
    setCurrentStage: (state, action: PayloadAction<string>) => {
      state.currentStage = action.payload;
    },
    /* 건물유형 */
    selectBuildingType: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentBuildingType = action.payload;
    },
    /* 평형 */
    selectPyung: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentPyung = action.payload;
    },
    /* 상담목적 */
    selectConsultPurpose: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentConsultPurpose = action.payload;
    },
    /* 거주여부 */
    selectSpaceStatus: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentSpaceStatus = action.payload;
    },
    selectConstructBudget: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentConstructionBudget = action.payload;
    },
    /* 공사일정 */
    selectConstructionPeriod: (
      state,
      action: PayloadAction<SeqValue | null>,
    ) => {
      state.currentConstructionPeriod = action.payload;
    },
    /* 공사범위B */
    selectConstructionCase: (state, action: PayloadAction<SeqValue[]>) => {
      if (action.payload?.length === 0) {
        state.currentConstructionCase = [];
        return;
      }
      const itemId = action.payload?.[0]?.id;
      const found = findIndex(state.currentConstructionCase, { id: itemId });
      if (found >= 0) {
        state.currentConstructionCase.splice(found, 1);
      } else {
        if (state.currentConstructionCase.length < 11) {
          state.currentConstructionCase.push(...action.payload);
        }
      }
    },
    /* 공사범위 전체선택 */
    selectAllCase: (state, action: PayloadAction<SeqValue[]>) => {
      if (state.currentConstructionCase.length === 11) {
        state.currentConstructionCase = [];
      } else {
        state.currentConstructionCase = [];
        state.currentConstructionCase.push(...action.payload);
      }
    },
    /* 상담일정 */
    selectConsultSchedule: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentConsultSchedule = action.payload;
    },
    /* 통화시간 */
    selectCallTime: (state, action: PayloadAction<SeqValue | null>) => {
      state.currentCallTime = action.payload;
    },
    /* 초기화 */
    reset: (state) => {
      state.currentStage = 'CHOOSE_BUILDING_TYPE';
      state.currentBuildingType = null;
      state.currentPyung = null;
      state.currentSpaceStatus = null;
      state.currentConsultPurpose = null;
      state.currentConstructionPeriod = null;
      state.currentConstructionCase = [];
      state.currentConsultSchedule = null;
      state.currentCallTime = null;
    },
    updateTelCertificated: (
      state,
      action: PayloadAction<{ telCertificated: boolean }>,
    ) => {
      state.telCertificated = action.payload.telCertificated;
    },
  },
});

export const {
  setCurrentStage,
  selectBuildingType,
  selectPyung,
  selectSpaceStatus,
  selectConsultPurpose,
  selectConstructBudget,
  selectConstructionCase,
  selectAllCase,
  selectConstructionPeriod,
  selectConsultSchedule,
  selectCallTime,
  updateTelCertificated,
  reset,
} = seqConsultSlice.actions;

export const selectSetCurrentStage = (state: RootState) =>
  state.seqConsult.currentStage;
export const selectCurrentBuildingType = (state: RootState) =>
  state.seqConsult.currentBuildingType;
export const selectCurrentPyung = (state: RootState) =>
  state.seqConsult.currentPyung;
export const selectCurrentSpaceStatus = (state: RootState) =>
  state.seqConsult.currentSpaceStatus;
export const selectCurrentConsultPurpose = (state: RootState) =>
  state.seqConsult.currentConsultPurpose;
export const selectCurrentConstructionBudget = (state: RootState) =>
  state.seqConsult.currentConstructionBudget;
export const selectCurrentConstructionCase = (state: RootState) =>
  state.seqConsult.currentConstructionCase;
export const selectCurrentConstructionPeriod = (state: RootState) =>
  state.seqConsult.currentConstructionPeriod;
export const selectCurrentConsultSchedule = (state: RootState) =>
  state.seqConsult.currentConsultSchedule;
export const selectCurrentCallTime = (state: RootState) =>
  state.seqConsult.currentCallTime;
export const selectTelCertificated = (state: RootState) =>
  state.seqConsult.telCertificated;

export default seqConsultSlice;
